import axios from "axios";
import Config from "../../config/index";
import {
  GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST,
  GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS,
  GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE,
  CREATE_MULTIPLE_DOWNLOAD_REQUEST,
  CREATE_MULTIPLE_DOWNLOAD_SUCCESS,
  CREATE_MULTIPLE_DOWNLOAD_FAILURE,
  GET_SINGLE_DOWNLOAD_REQUEST,
  GET_SINGLE_DOWNLOAD_SUCCESS,
  GET_SINGLE_DOWNLOAD_FAILURE,
} from "./documentDownloadCenterTypes";

let baseUrl = Config.baseUrl;

const getDocumentDownloadCenterRequest = () => {
  return {
    type: GET_DOCUMENT_DOWNLOAD_CENTER_REQUEST,
  };
};

const getDocumentDownloadCenterSuccess = (payload) => {
  return {
    type: GET_DOCUMENT_DOWNLOAD_CENTER_SUCCESS,
    payload: payload,
  };
};

const getDocumentDownloadCenterFailure = (error) => {
  return {
    type: GET_DOCUMENT_DOWNLOAD_CENTER_FAILURE,
    payload: error,
  };
};

const getDocumentDownloadCenter = (
  vendoCode,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDocumentDownloadCenterRequest());
    let url = `${baseUrl}/vendor/download_center/get?vendorCode=${vendoCode}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDocumentDownloadCenterSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDocumentDownloadCenterFailure(err.message));
      });
  };
};

const createMultipleDownloadRequest = () => {
  return {
    type: CREATE_MULTIPLE_DOWNLOAD_REQUEST,
  };
};

const createMultipleDownloadSuccess = (payload) => {
  return {
    type: CREATE_MULTIPLE_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const createMultipleDownloadFaliure = (error) => {
  return {
    type: CREATE_MULTIPLE_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const createMultipleDownload = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  return (dispatch) => {
    dispatch(createMultipleDownloadRequest());
    let url = `${baseUrl}/vendor/download_center/multi_vendor`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createMultipleDownloadSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createMultipleDownloadFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getSingleDownloadRequest = () => {
  return {
    type: GET_SINGLE_DOWNLOAD_REQUEST,
  };
};

const getSingleDownloadSuccess = (payload) => {
  return {
    type: GET_SINGLE_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const getSingleDownloadFailure = (error) => {
  return {
    type: GET_SINGLE_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const getSingleDownload = (email, name, type, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSingleDownloadRequest());
    let url = `${baseUrl}/vendor/download_center/single_doc?email=${email}&file_name=${name}&file_type=${type}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSingleDownloadSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getSingleDownloadFailure(err.message));
      });
  };
};

export { getDocumentDownloadCenter, createMultipleDownload, getSingleDownload };
